let _ctx = null;

function ctx() {
  if (!_ctx) {
    try { _ctx = new (window.AudioContext || window.webkitAudioContext)(); }
    catch { return null; }
  }
  if (_ctx.state === 'suspended') _ctx.resume();
  return _ctx;
}

function chime(freqs) {
  const c = ctx();
  if (!c) return;
  freqs.forEach((freq, i) => {
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.connect(gain);
    gain.connect(c.destination);
    osc.type = 'triangle';
    osc.frequency.value = freq;
    const t = c.currentTime + i * 0.075;
    gain.gain.setValueAtTime(0.001, t);
    gain.gain.linearRampToValueAtTime(0.09, t + 0.012);
    gain.gain.exponentialRampToValueAtTime(0.001, t + 0.38);
    osc.start(t);
    osc.stop(t + 0.42);
  });
}

export const sounds = {
  // Clean tick — short sine burst like a clock tick
  navClick: () => {
    const c = ctx();
    if (!c) return;
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.connect(gain);
    gain.connect(c.destination);
    osc.type = 'sine';
    osc.frequency.value = 1300;
    gain.gain.setValueAtTime(0.06, c.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, c.currentTime + 0.022);
    osc.start(c.currentTime);
    osc.stop(c.currentTime + 0.025);
  },

  // Ascending triad C5–E5–G5 → going dark
  themeOn:  () => chime([523.25, 659.25, 783.99]),

  // Descending triad G5–E5–C5 → going light
  themeOff: () => chime([783.99, 659.25, 523.25]),

  // Little "mee-ow": a buzzy sawtooth through a band-pass whose centre slides
  // bright → dark, with a pitch rise and fall and a touch of vibrato.
  meow: () => {
    const c = ctx();
    if (!c) return;
    const t = c.currentTime;
    const pitch = 1 + (Math.random() - 0.5) * 0.16;   // no two meows alike
    const osc = c.createOscillator();
    const filter = c.createBiquadFilter();
    const gain = c.createGain();
    const lfo = c.createOscillator();
    const lfoGain = c.createGain();
    osc.type = 'sawtooth';
    filter.type = 'bandpass';
    filter.Q.value = 5;
    lfo.frequency.value = 7;
    lfoGain.gain.value = 14;
    lfo.connect(lfoGain);
    lfoGain.connect(osc.frequency);
    osc.connect(filter);
    filter.connect(gain);
    gain.connect(c.destination);

    osc.frequency.setValueAtTime(560 * pitch, t);
    osc.frequency.linearRampToValueAtTime(860 * pitch, t + 0.13);
    osc.frequency.linearRampToValueAtTime(700 * pitch, t + 0.32);
    osc.frequency.linearRampToValueAtTime(480 * pitch, t + 0.55);
    filter.frequency.setValueAtTime(1000, t);
    filter.frequency.linearRampToValueAtTime(2400, t + 0.14);
    filter.frequency.linearRampToValueAtTime(900, t + 0.55);
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(0.16, t + 0.05);
    gain.gain.setValueAtTime(0.16, t + 0.3);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.6);

    osc.start(t); lfo.start(t);
    osc.stop(t + 0.62); lfo.stop(t + 0.62);
  },
};
